import {AnalyticsSettings} from '../state/analytics.state';
import {GetAnalyticsRequest} from '../models/analytics/analytics.request';

export namespace Analytics {
  export class GetAnalytics {
    static readonly type = '[Analytics api] Get Analytics';

    constructor(public request: GetAnalyticsRequest) {
    }
  }

  export class UpdateAnalyticsSettings {
    static readonly type = '[Analytics api] Update Analytics Settings';

    constructor(public settings: AnalyticsSettings) {
    }
  }
}

